import PaymentReturn from '../components/payment-return/PaymentReturn.svelte';

const tagName = 'teuteuf-payment-return';

const element = PaymentReturn.element;

if (element && !customElements.get(tagName)) {
  customElements.define(tagName, element);
}
